import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { StoresService } from './shared/services/stores.service';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { localStorageSync } from 'ngrx-store-localstorage';
import { shopReducer } from './shared/ngrxState/shop.reducer';

export function localStorageSyncReducer(reducer: any) {
  return localStorageSync({ keys: ['shop'], rehydrate: true })(reducer);
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    RouterModule,
    StoreModule.forRoot(
      { shop: shopReducer },
      { metaReducers: [localStorageSyncReducer] }
    ),
    StoreDevtoolsModule.instrument({ maxAge: 25 }),
  ],
  providers: [TranslateModule,StoresService],
  bootstrap: [AppComponent]
})
export class AppModule { }
